import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { dictionary } from '../assets/constant/dictionary';
import { apiCall, createSession, RequestConfigs } from '../api';
import { SessionData } from 'react-router-dom';
import { useLoader } from './LoaderContext';
import { lang } from 'moment';
import { ContactContextType, useContactType } from './ContactContext';
import { create } from 'domain';
import { useVendorType, VendorContextType } from './VendorContext';

interface DictionaryElement {
    key: string;
    en: string;
    he: string;
}

interface DictionaryContextProps {
    translate: (key: string,prefix?:string) => string;
    changeLanguage: (lang: string) => void;
}

const DictionaryContext = createContext<DictionaryContextProps | undefined>(undefined);

interface DictionaryProviderProps {
    children: ReactNode;
}

const getDictionary = async (
    language: string,
    setTranslations: React.Dispatch<React.SetStateAction<Record<string, string>>>,
    setGlobalLoading: React.Dispatch<React.SetStateAction<boolean>>,
    contactContext:ContactContextType,
    vendorContext:VendorContextType
) => {
    const baseTranslations = mapDictionary(language, dictionary,{})
    setTranslations(baseTranslations);
    await createSession();
    const responseData = await apiCall({ requestType: RequestConfigs.dictionary }, setGlobalLoading,contactContext,vendorContext);
    if (responseData?.dictionary) {
        const newTranslations = mapDictionary('he', responseData.dictionary,baseTranslations);
        setTranslations(newTranslations);
    }


}


export const DictionaryProvider: React.FC<DictionaryProviderProps> = ({ children }) => {
    const [language, setLanguage] = useState<string>('he');
    const [translations, setTranslations] = useState<Record<string, string>>({});
    const {setLoading} = useLoader();
    const contactContext = useContactType();
    const vendorContext = useVendorType();

    useEffect(() => {
        getDictionary(language,setTranslations, setLoading,contactContext,vendorContext);
    }, []);

    const translate = (key: string,prefix?:string): string => {
        let translationKey = key;
        if (prefix) {
            translationKey = `${prefix}.${key}`;
        }
        return translations[translationKey] || key;
    };

    const changeLanguage = (lang: string): void => {
        setLanguage(lang);
        getDictionary(lang,setTranslations, setLoading,contactContext,vendorContext)
    };

    return (
        <DictionaryContext.Provider value={{ translate, changeLanguage }}>
            {children}
        </DictionaryContext.Provider>
    );
};

export const useDictionary = (): DictionaryContextProps => {
    const context = useContext(DictionaryContext);
    if (!context) {
        throw new Error('useDictionary must be used within a DictionaryProvider');
    }
    return context;
};

const mapDictionary = (language: string, dictionary: DictionaryElement[],translations:Record<string, string>): Record<string, string> => {
    
    dictionary.forEach((item: any) => {
        translations[item.key] = item[language];
    });
    return translations;
};